export default {
  barcode: {
    one: 'Barcode',
    many: 'Barcodes',
  },
  actions: {
    continue: 'Continue',
    reload: 'Reload',
    start: 'Start Scanner',
  },
  warnings: {
    browser: {
      partialSupport: {
        title: 'Partially Supported Browser',
        message1:
          "Looks like the platform/browser combination you're using supports only a part of the features needed to fully experience this demo (no direct access to video feed possible).",
        message2: 'It is likely this is due to using a limited WebView or a browser which is not Safari on iOS.',
        message3:
          'Please use any of the following browsers in order to be able to enjoy the full experience, or continue to try the "single image mode" (decoding from a single picture) limited fallback experience.',
      },
      unsupported: {
        title: 'Unsupported Browser',
        message: 'Please use any of the following browsers in order to be able to access this content.',
      },
    },
    camera: {
      noAccess: 'No Camera Access',
      accessDenied: 'Camera access denied',
      permissionRequest: 'Please grant camera access and reload this page in order to use this application.',
      notAvailable: 'No Camera available',
      notAvailableMessage: "Seems there's no camera on your device",
      notAvailableButSingleImageModeMessage:
        'You can continue and try the "single image mode" (decoding from a single picture) limited fallback experience.',
    },
  },
  errors: {
    license: {
      title: 'License Error',
      message: 'Please check that your license key is valid or has not expired',
    },
  },
  info: {
    loading: 'Loading the first time could take a while...',
    camera: {
      accessing: 'Accessing <br /> Camera...',
      accessingMessage: "Don't worry. This can also happen in the background!",
    },
    fullscreen: {
      touch: {
        enter: 'Double tap to enter fullscreen mode',
        exit: 'Double tap to exit fullscreen mode',
      },
      click: {
        enter: 'Double click to enter fullscreen mode',
        exit: 'Double click to exit fullscreen mode',
      },
    },
    signUpTrial: 'Interested? <u>Sign Up for Trial</u>.',
    extendSymbolsCounts: {
      message: 'Some symbologies accept only specific symbol count ranges (lengths) by default, see',
      documentationLinkText: 'documentation',
      message2:
        'To scan outside of the default lengths, use the following toggle (will slightly slow down the scanner,make sure to activate only the needed symbologies):',
    },
  },
  intro: {
    title: 'Data Capture SDK for the Web',
    sdkDescription:
      'The Scandit Web SDK is a JavaScript library which leverages WebAssembly to bring powerful barcode scanning technology to the browser, allowing customers to integrate scanning via smartphone or desktop cameras directly into any mobile and desktop web application.',
    selectModeMessage: 'To experience our scanner in the browser, please choose a mode below:',
    moreInfo1: 'Find out more information on our',
    moreInfo2: 'JavaScript / TypeScript barcode scanner',
  },
  options: {
    barcodes: 'Barcodes',
    colorInverted: 'Color Inverted',
    soundEffects: 'Sound <br /> Effects',
    duplicateFilter: 'Duplicate <br /> Filter',
    extendSymbolsCounts: 'Use Extended Symbol Counts',
  },
  videoResolutions: {
    hd: 'HD',
    fullHd: 'Full HD',
    uhd4k: '4k',
  },
  scannerModePresets: {
    '1dRetail': '1D Retail',
    qr: 'QR Codes',
    '1dIndustrial': '1D Industrial',
    dpm: 'DPM Codes',
    all2d: 'All 2D Codes',
    all: 'All Symbologies',
    swissQR: 'Swiss QR-bill',
    batch: 'Batch',
    externalSearchAndFind: 'Search And Find',
    externalListBuilding: 'List Building',
    batchDescription: 'Use MatrixScan to scan multiple barcodes at once',
    externalSearchAndFindDescription: 'Use MatrixScan Find to locate products with AR guidance.',
    externalListBuildingDescription: 'Use SparkScan to populate a list of scanned barcodes',
  },
  tutorial: {
    title: 'Quick Tutorial',
    message: "<p>Welcome</p><p>Here's a short overview of what you can do with this demo app.</p>",
    next: 'Next Tip',
    start: 'Start Scanning',
    steps: {
      step1: 'Choose which symbologies are enabled/disabled',
      step2: 'Switch between different cameras available on your device',
      step3: 'Toggle beeping sound played on barcode recognition',
      step4: 'Filter the same barcode being scanned more than once per second',
      step5: 'Scanned barcodes will appear here',
    },
  },
}
